export default "__VITE_ASSET__XbQAWvxj__"